import ClaimInfo from './ClaimInfo';

export default ClaimInfo;
